import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports: [
    ChartModule, TableModule, ToolbarModule, DialogModule, InputTextModule, InputSwitchModule, InputNumberModule, 
    IconFieldModule, InputIconModule, DropdownModule, ToastModule, ConfirmDialogModule, TreeModule, TreeSelectModule, 
    MultiSelectModule, CardModule, CalendarModule, FormsModule, 
  ],
  providers: [ConfirmationService]
})
export class PrimengModule { }
